import React from 'react'
import { Node } from './canvas-utils';
import { useQuery } from '@tanstack/react-query';
import { automationsService } from 'services/admin/automationsService';
import { Table, TableRow, TableHead, TableCell, TableBody, Typography } from '@mui/material';
import { toDate } from 'helpers/dateHelper';
import { ActiveTarget } from './AutomationConstructor';
import _ from 'lodash';

interface ButtonStatsDialogProps {
  target: ActiveTarget;
  automationID: number;
}
export const ButtonStatsDialog = ({ target, automationID }: ButtonStatsDialogProps) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['button-stats', target?.entityID, target?.payload?.button?.id],
    queryFn: () => automationsService.getButtonStats(automationID, target?.entityID, target?.payload?.button?.id),
  });


  return (
    <div>
      <div className="text-lg">Статистика по кнопке <span className="font-bold">"{target?.payload?.button?.text}"</span> - {data?.length} раз нажали</div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>Контакт</TableCell>
            <TableCell>Дата получения</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item: any) => (
            <TableRow key={item.id}>
              {/* Avatar */}
              <TableCell>
                <img
                  src={item.contact?.externalUserPhoto ? item.contact?.externalUserPhoto : "/media/images/avatar_f.jpg"}
                  alt={item.contact?.externalUserUserName || "Фото контакта"}
                  className="w-10 h-10 rounded-full"
                />
              </TableCell>
              <TableCell>{item.contact.externalUserUserName || item.contact.externalUserID}</TableCell>
              <TableCell>{toDate(item.createdAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
